import { useMemo } from 'react'

import { TradingVenueScope } from '@/lib/trading-venue-scope'
import { buildAccountVenueIndex } from '@/lib/utils/account-venue-index'
import { useUserAccounts } from '@/service/account.hook'
import { TradeVenue } from '@/types/generated/common/types'

/**
 * The `matchesTradingVenue` scope for a widget pinned to `targetVenue`. While the
 * account list is still loading, `activeAccountIds` is left undefined so rows aren't
 * all filtered out by an empty set.
 */
export function useTradingVenueScope(targetVenue: TradeVenue | undefined): TradingVenueScope {
  const { data: userAccountsData } = useUserAccounts({ showDisabled: true })
  const index = useMemo(
    () => (userAccountsData ? buildAccountVenueIndex(userAccountsData.accounts) : undefined),
    [userAccountsData]
  )
  return useMemo(
    () => ({
      targetVenue,
      activeAccountIds: index?.activeAccountIds,
      accountVenueById: index?.accountVenueById ?? EMPTY_VENUE_BY_ID,
    }),
    [targetVenue, index]
  )
}

const EMPTY_VENUE_BY_ID: ReadonlyMap<string, TradeVenue> = new Map()
